const UHC_PROD_CHAT_API_URL = 'https://health-safe-hte-agent.uhg.com/v2/healthtech-chat';

// Shared chat endpoint path used by the RN app (packages/chat-widget/src/services/ChatApiService.ts).
const CHAT_ENDPOINT_PATH = '/services/psx-structured-provider-convo-agent/v2/healthtech-chat';

// Real chat host observed in the RN app network trace (Cloudflare-fronted, publicly reachable).
const CHAT_BASE_URL = 'https://healthtech-chat.optum.com';

const DEFAULT_CHAT_API_URL = `${CHAT_BASE_URL}${CHAT_ENDPOINT_PATH}`;

const ENVIRONMENT_PRODUCTION = 'production';
const HostAppName = {
  UHC: 'UHC',
} as const;

type HostAppName = (typeof HostAppName)[keyof typeof HostAppName];
type EnvironmentName = string;

interface ChatApiEndpointContext {
  environmentName?: EnvironmentName;
  hostAppName?: HostAppName;
}

export const resolveChatApiUrl = ({
  environmentName,
  hostAppName,
}: ChatApiEndpointContext): string => {
  if (environmentName === ENVIRONMENT_PRODUCTION && hostAppName === HostAppName.UHC) {
    return UHC_PROD_CHAT_API_URL;
  }

  return DEFAULT_CHAT_API_URL;
};

export const getChatApiUrl = (): string => {
  // BFF flow: the SPA calls its OWN backend (with the session cookie), and the
  // backend calls the HealthTech Chat API server-side and returns the SSE response.
  // The same-origin `/secure/api` path is proxied to the backend by Vite in dev and
  // served by nginx in prod. Override with VITE_CHAT_API_URL when needed.
  //
  // Endpoint: POST /secure/api/conversation (matches OptumusMessagingController.java)
  // Request body: { prompt: string }
  // Response: text/event-stream (SSE)
  return import.meta.env.VITE_CHAT_API_URL || '/secure/api/conversation';
};
